import { debounce } from 'throttle-debounce';

export function initScrollbar() {

	measureScrollbar();
	window.addEventListener('resize', debounce(200, measureScrollbar));


}

function measureScrollbar() {
	let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
	document.body.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
}
